import { Form, Formik } from "formik";
import validationSchema from "../../../Validation/ValidationSchemas";
import FormikTextField from "../../../Common/FormFields/FormikInputField";
import { useEffect, useRef, useState } from "react";
import { FormGroup } from "reactstrap";
import CustomDropDown from "../../../Common/FormFields/CustomDropDown";
import { useDispatch, useSelector } from "react-redux";
import {
  addBreakdown,
  isEditBreakDownValue,
  resetBreakDownValues,
  setBreakDownList,
  toggleAddOrEditBreakDownPopUp,
  updateBreakDown,
} from "../../../Redux/Actions/ManageBreakDownAction";
import LoadingButton from "../../../Common/LoadingButton";
import HoverToolTip from "../../../Common/ToolTips/HoverToolTips/HoverToolTip";
import DialogBox from "./ReusablePopup/DialogBox";
import styles from "../videoPlayer/Breakdowns/ManageBreakdown.module.css";
import { openConfirmationPopup } from "../../../Redux/Actions/PopupActions";
import { breakDownTypeOptions } from "../../../utils/constant";
import { getFromLocalStorage } from "../../../utils/webStorage";
import { FaTimes } from "react-icons/fa";

const AddOrEditBreakDown = ({
  searchQuery,
  page,
  pageSize,
  defaultColumnSetName,
}) => {
  const currentUserId = getFromLocalStorage("currentUserId");
  const schoolId = getFromLocalStorage("schoolId");
  const open = useSelector((state) => state.manageBreakDownData?.open);
  const {
    isEditBreakDown,
    breakDownInformation: breakDownData,
    breakDownTable: { buttonLoading, pageState, searchedRecord },
  } = useSelector((state) => state?.manageBreakDownData);
  const dispatch = useDispatch();
  const [breakDownTypeOption, setBreakDownTypeOption] = useState("");
  const [count, setCount] = useState(0);
  const { selectedColumnSet } = useSelector(
    (state) => state?.VideoLibraryDataTable
  );

  useEffect(() => {
    setBreakDownTypeOption(
      isEditBreakDown ? breakDownData?.breakdownType?.breakdownTypeName : ""
    );
    setCount(
      isEditBreakDown
        ? breakDownData?.possibleValues !== ""
          ? breakDownData?.possibleValues?.split(",")?.length
          : 0
        : 0
    );
  }, [breakDownData, open]);

  const formRef = useRef();

  const handleClose = (formik) => {
    setBreakDownTypeOption("");
    isEditBreakDownValue(dispatch, false);
    toggleAddOrEditBreakDownPopUp(dispatch, false);
    handleFormReset(formik);
  };

  const handleFormReset = (formik) => {
    formik.resetForm({
      values: {
        breakDownName: "",
        breakDownType: "",
        possibleValue: "",
      },
    });
    if (isEditBreakDown) {
      resetBreakDownValues(dispatch);
    }
    setBreakDownTypeOption("");
    setCount(0);
  };

  const handleDelete = () => {
    if (!breakDownData?.isDefault) {
      openConfirmationPopup(dispatch, {
        confirmationPopup: {
          open: true,
          message: "Are You Sure You Want To Delete This Breakdown?",
          btnColor: "red",
          btnText: "Delete",
          type: "Delete Breakdown",
          breakDownId: breakDownData?.id,
          breakDownList: pageState,
          searchedRecord,
          searchQuery,
          schoolId,
          currentUserId,
        },
      });
    }
  };

  const getUpdatedBreakdown = () => {
    setBreakDownList(dispatch, {
      page,
      pageSize,
      currentUserId,
      defaultColumnSetName: selectedColumnSet?.columnName,
    });
  };

  const handleSubmit = (values) => {
    const columnNameId = selectedColumnSet?.id;
    isEditBreakDown
      ? updateBreakDown(dispatch, {
          ...values,
          breakDownId: breakDownData?.id,
          schoolId: schoolId,
          //for updating values
          getUpdatedBreakdown: getUpdatedBreakdown,
        })
      : addBreakdown(dispatch, { ...values, schoolId, columnNameId }).then(
          () => {
            handleFormReset(formRef?.current);
          }
        );
  };

  return (
    <Formik
      initialValues={{
        breakDownName: isEditBreakDown ? breakDownData?.breakdownName : "",
        breakDownType: isEditBreakDown ? breakDownData?.breakdownType?.id : "",
        possibleValue: isEditBreakDown
          ? breakDownData?.possibleValues?.split(",")
          : [""],
      }}
      validationSchema={validationSchema.breakDownSchema}
      innerRef={formRef}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {(formik) => (
        <Form>
          <DialogBox
            open={open}
            onClose={() => handleClose(formik)}
            title={
              <div className="d-flex-space-between">
                <p className="bold">
                  {isEditBreakDown
                    ? `Edit : ${formik?.values?.breakDownName} ${
                        formik?.values?.breakDownName &&
                        breakDownData?.isDefault
                          ? "(D)"
                          : ""
                      }`
                    : "Add Breakdown"}
                </p>
                <FaTimes
                  onClick={() => handleClose(formik)}
                  className="crossview cp"
                />
              </div>
            }
            variant={"md"}
            disabled={buttonLoading?.addEdit}
          >
            <div
              className={`addFilterPopupContent ${styles.AddEditBreakDownGridContainer}`}
            >
              <FormikTextField
                label="Breakdown Name"
                formik={formik}
                fieldName="breakDownName"
                placeholder="Enter Breakdown name"
                labelFontSize="fs-18"
              />
              <FormGroup>
                <label className="fmlabel mt-6 semi-bold fs-18">
                  Type<span className="redstar"> *</span>
                </label>
                <CustomDropDown
                  selected={breakDownTypeOption}
                  setSelected={setBreakDownTypeOption}
                  formik={formik}
                  fieldName="breakDownType"
                  defaultSelectOption="Select BreakDown"
                  options={breakDownTypeOptions}
                  fieldToShow="name"
                  optionValue="id"
                />
              </FormGroup>
              <div className={styles.divider}></div>
              <div>
                <label className={`fmlabel mt-6 semi-bold font-rajdhani fs-18`}>
                  Possible Values {<span className="redstar">*</span>}
                </label>
                {Array.from(Array(count))?.map((item, index) => (
                  <div className={styles.possibleValuesContainer} key={index}>
                    <>
                      <div
                        className={`d-flex flex-direction-c position-relative ${
                          formik?.errors?.possibleValue?.[index] &&
                          "mg-bottom-10"
                        }`}
                      >
                        <FormikTextField
                          label=""
                          formik={formik}
                          fieldName={`possibleValue.${[index]}`}
                          placeholder="Enter Possible value"
                          labelFontSize="fs-18"
                        />
                        <div
                          className={`errorMsg fs-14 medium ${styles.errorMessage}`}
                        >
                          {formik?.errors?.possibleValue?.[index] &&
                            formik?.errors?.possibleValue?.[index]}
                        </div>
                      </div>
                      <div>
                        <button
                          type="button"
                          className={`${styles.button} ${styles.bgRed} text-white semi-bold`}
                          onClick={() => {
                            setCount((prevCount) => prevCount - 1);
                            const newPossibleValues = [
                              ...formik.values.possibleValue,
                            ];
                            newPossibleValues.splice(index, 1);
                            formik.setFieldValue(
                              "possibleValue",
                              newPossibleValues
                            );
                          }}
                        >
                          Delete
                        </button>
                      </div>
                    </>
                    {index === count - 1 && (
                      <>
                        <div
                          className={`d-flex flex-direction-c position-relative ${
                            formik?.errors?.possibleValue?.[index + 1] &&
                            "mg-bottom-10"
                          }`}
                        >
                          <FormikTextField
                            label=""
                            formik={formik}
                            fieldName={`possibleValue.${[index + 1]}`}
                            placeholder="Enter Possible value"
                            labelFontSize="fs-18"
                          />
                          <div
                            className={`errorMsg fs-14 medium ${styles.errorMessage}`}
                          >
                            {formik?.errors?.possibleValue?.[index + 1] &&
                              formik?.errors?.possibleValue?.[index + 1]}
                          </div>
                        </div>
                        <div>
                          <button
                            type="button"
                            className={`${styles.button} ${
                              styles.bgLightGrey
                            } text-dark semi-bold ${
                              (formik?.errors?.possibleValue?.[index + 1] ||
                                !formik?.values?.possibleValue?.[index + 1]) &&
                              styles.disabled
                            }`}
                            onClick={() => setCount((prev) => prev + 1)}
                            disabled={
                              formik?.errors?.possibleValue?.[index + 1] ||
                              !formik?.values?.possibleValue?.[index + 1]
                            }
                          >
                            Add
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                ))}
                {count === 0 && (
                  <div className={styles.possibleValuesContainer}>
                    <div
                      className={`d-flex flex-direction-c position-relative`}
                    >
                      <FormikTextField
                        label=""
                        formik={formik}
                        fieldName={`possibleValue.${0}`}
                        placeholder="Enter Possible value"
                        labelFontSize="fs-18"
                      />
                      <div
                        className={`errorMsg fs-14 medium ${styles.errorMessage}`}
                      >
                        {formik?.errors?.possibleValue?.[0] &&
                          formik?.errors?.possibleValue?.[0]}
                      </div>
                    </div>
                    <div>
                      <button
                        type="button"
                        className={`${styles.button} ${
                          styles.bgLightGrey
                        } text-dark semi-bold ${
                          (formik?.errors?.possibleValue?.[0] ||
                            !formik?.values?.possibleValue?.[0]) &&
                          styles.disabled
                        }`}
                        onClick={() => setCount(1)}
                        disabled={
                          formik?.errors?.possibleValue?.[0] ||
                          !formik?.values?.possibleValue?.[0]
                        }
                      >
                        Add
                      </button>
                    </div>
                  </div>
                )}
              </div>

              <div
                className={`d-flex-space-between gap-10 ${styles.AddEditBreakDownFooter}`}
              >
                <div className={styles.temp}>
                  <p
                    className={`semi-bold fs-17 ${styles.underlinedLink} ${styles.clear}`}
                    onClick={() => handleFormReset(formik)}
                  >
                    Clear All Values
                  </p>
                  {isEditBreakDown && (
                    <HoverToolTip
                      content={<span>Default Breakdown Cannot Be Deleted</span>}
                      showToolTip={breakDownData?.isDefault}
                      variant="sm"
                      trigger="hover"
                    >
                      <p
                        className={`semi-bold fs-17 ${styles.underlinedLink} ${styles.delete}`}
                        onClick={handleDelete}
                      >
                        Delete {formik?.values?.breakDownName}
                      </p>
                    </HoverToolTip>
                  )}
                </div>
                <div onClick={() => formik.submitForm()}>
                  <LoadingButton
                    // text={isEditBreakDown ? "Request" : "Add"}
                    text={"Add"}
                    loading={buttonLoading?.addEdit}
                    disabled={
                      !formik.isValid || !formik?.values?.possibleValue?.[0]
                    }
                  />
                </div>
              </div>
            </div>
          </DialogBox>
        </Form>
      )}
    </Formik>
  );
};

export default AddOrEditBreakDown;
